export interface TimeSlicePreset {
  id: string
  displayName: string
  description: string
  parameters: {
    mode: 'first' | 'last' | 'max' | 'min'
    startOffset: number
    startTime: string
    endOffset: number
    endTime: string
  }
  defaultField?: string // Default field selection (high, low, close, etc.)
}

export const timeSlicePresets: Record<string, TimeSlicePreset> = {
  'premarket-high': {
    id: 'premarket-high',
    displayName: 'Premarket High',
    description: 'Highest value during premarket hours (04:00-09:30)',
    parameters: {
      mode: 'max',
      startOffset: 0,
      startTime: '04:00',
      endOffset: 0,
      endTime: '09:30',
    },
    defaultField: 'high',
  },
  'premarket-low': {
    id: 'premarket-low',
    displayName: 'Premarket Low',
    description: 'Lowest value during premarket hours (04:00-09:30)',
    parameters: {
      mode: 'min',
      startOffset: 0,
      startTime: '04:00',
      endOffset: 0,
      endTime: '09:30',
    },
    defaultField: 'low',
  },
  'yesterday-afterhours-high': {
    id: 'yesterday-afterhours-high',
    displayName: "Yesterday's Afterhours High",
    description: "Highest value during yesterday's afterhours (16:00-20:00)",
    parameters: {
      mode: 'max',
      startOffset: 1,
      startTime: '16:00',
      endOffset: 1,
      endTime: '20:00',
    },
    defaultField: 'high',
  },
  'yesterday-afterhours-low': {
    id: 'yesterday-afterhours-low',
    displayName: "Yesterday's Afterhours Low",
    description: "Lowest value during yesterday's afterhours (16:00-20:00)",
    parameters: {
      mode: 'min',
      startOffset: 1,
      startTime: '16:00',
      endOffset: 1,
      endTime: '20:00',
    },
    defaultField: 'low',
  },
  'yesterday-high': {
    id: 'yesterday-high',
    displayName: 'Yesterday High',
    description: "Highest value during yesterday's regular session (09:30-16:00)",
    parameters: {
      mode: 'max',
      startOffset: 1,
      startTime: '09:30',
      endOffset: 1,
      endTime: '16:00',
    },
    defaultField: 'high',
  },
  'yesterday-low': {
    id: 'yesterday-low',
    displayName: 'Yesterday Low',
    description: "Lowest value during yesterday's regular session (09:30-16:00)",
    parameters: {
      mode: 'min',
      startOffset: 1,
      startTime: '09:30',
      endOffset: 1,
      endTime: '16:00',
    },
    defaultField: 'low',
  },
  'previous-close': {
    id: 'previous-close',
    displayName: 'Previous Close',
    description: "Last value from yesterday's regular session (09:30-16:00)",
    parameters: {
      mode: 'last',
      startOffset: 1,
      startTime: '09:30',
      endOffset: 1,
      endTime: '16:00',
    },
    defaultField: 'close',
  },
}

// Helper function to check if a node's parameters match a preset
export function matchPreset(parameters: Record<string, unknown>): string | null {
  for (const [presetId, preset] of Object.entries(timeSlicePresets)) {
    const params = preset.parameters
    if (
      parameters.mode === params.mode &&
      parameters.startOffset === params.startOffset &&
      parameters.startTime === params.startTime &&
      parameters.endOffset === params.endOffset &&
      parameters.endTime === params.endTime
    ) {
      return presetId
    }
  }
  return null
}
